import { useEffect } from "react";

interface UseEscapeKeyOptions {
  enabled?: boolean;
}

export const useEscapeKey = (onEscape: () => void, options: UseEscapeKeyOptions = {}) => {
  const { enabled = true } = options;

  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onEscape();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled, onEscape]);
};
